// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.home_kpi_main {
    max-width: 100%;
    padding: 20px 24px;
    border-radius: var(--radius-md);
    background-color: var(--bg-card);
    box-shadow: var(--shadow-sm);
    border: 1px solid var(--border-light);
}

.kpi_container {
    width: 100%;
    display: grid;
    grid-template-columns: repeat(3, 1fr);
    gap: 14px;
    padding: 16px 0 4px;
}

.kpi_box {
    background-color: var(--bg-card);
    max-width: 100%;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: end;
    padding: 16px 20px;
    gap: 6px;
    border-radius: var(--radius-md);
    border: 1px solid var(--border);
    transition: all var(--transition-fast);
}

.kpi_box:hover {
    box-shadow: var(--shadow-md);
    border-color: var(--primary-50);
}

.kpi_box p {
    margin: 0;
}

.kpi_box_datas {
    display: flex;
    flex-direction: row;
    align-items: center;
    gap: 10px;
}

.home_kpi_toggle {
    width: 100%;
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    align-items: center;
}

.home_kpi_toggle p {
    margin: 0;
    font-size: 15px;
    font-weight: 600;
    color: var(--text-primary);
}

.home_kpi_lists {
    max-height: 0;
    overflow: hidden;
    transition: max-height 0.4s ease-in-out;
}

.home_kpi_lists_transition {
    max-height: 5000px;
}

/************ TOGGLE ************/
.toggle {
    cursor: pointer;
    display: inline-block;
}

.toggle-switch {
    display: inline-block;
    background: var(--border);
    border-radius: 16px;
    width: 44px;
    height: 24px;
    position: relative;
    vertical-align: middle;
    transition: background 0.25s;
}

.toggle-switch:before,
.toggle-switch:after {
    content: "";
}

.toggle-switch:before {
    display: block;
    background: var(--bg-card);
    border-radius: 50%;
    box-shadow: var(--shadow-sm);
    width: 18px;
    height: 18px;
    position: absolute;
    top: 3px;
    left: 3px;
    transition: left 0.25s;
}

.toggle:hover .toggle-switch:before {
    box-shadow: var(--shadow-md);
}

.toggle-checkbox:checked + .toggle-switch {
    background: var(--primary);
}

.toggle-checkbox:checked + .toggle-switch:before {
    left: 23px;
}

.toggle-checkbox {
    position: absolute;
    visibility: hidden;
}

.toggle-label {
    margin-left: 8px;
    position: relative;
    top: 2px;
    font-weight: 500;
    color: var(--text-secondary);
}

@media screen and (max-width: 1200px) {
    .kpi_container {
        grid-template-columns: repeat(2, 1fr);
    }
}

@media screen and (max-width: 768px) {
    .kpi_container {
        grid-template-columns: 1fr;
    }
}
`, "",{"version":3,"sources":["webpack://./src/components/DataComponents/KPI/KPI.css"],"names":[],"mappings":"AAAA;IACI,eAAe;IACf,kBAAkB;IAClB,+BAA+B;IAC/B,gCAAgC;IAChC,4BAA4B;IAC5B,qCAAqC;AACzC;;AAEA;IACI,WAAW;IACX,aAAa;IACb,qCAAqC;IACrC,SAAS;IACT,mBAAmB;AACvB;;AAEA;IACI,gCAAgC;IAChC,eAAe;IACf,aAAa;IACb,sBAAsB;IACtB,uBAAuB;IACvB,gBAAgB;IAChB,kBAAkB;IAClB,QAAQ;IACR,+BAA+B;IAC/B,+BAA+B;IAC/B,sCAAsC;AAC1C;;AAEA;IACI,4BAA4B;IAC5B,+BAA+B;AACnC;;AAEA;IACI,SAAS;AACb;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,mBAAmB;IACnB,SAAS;AACb;;AAEA;IACI,WAAW;IACX,aAAa;IACb,mBAAmB;IACnB,8BAA8B;IAC9B,mBAAmB;AACvB;;AAEA;IACI,SAAS;IACT,eAAe;IACf,gBAAgB;IAChB,0BAA0B;AAC9B;;AAEA;IACI,aAAa;IACb,gBAAgB;IAChB,uCAAuC;AAC3C;;AAEA;IACI,kBAAkB;AACtB;;AAEA,iCAAiC;AACjC;IACI,eAAe;IACf,qBAAqB;AACzB;;AAEA;IACI,qBAAqB;IACrB,yBAAyB;IACzB,mBAAmB;IACnB,WAAW;IACX,YAAY;IACZ,kBAAkB;IAClB,sBAAsB;IACtB,4BAA4B;AAChC;;AAEA;;IAEI,WAAW;AACf;;AAEA;IACI,cAAc;IACd,0BAA0B;IAC1B,kBAAkB;IAClB,4BAA4B;IAC5B,WAAW;IACX,YAAY;IACZ,kBAAkB;IAClB,QAAQ;IACR,SAAS;IACT,sBAAsB;AAC1B;;AAEA;IACI,4BAA4B;AAChC;;AAEA;IACI,0BAA0B;AAC9B;;AAEA;IACI,UAAU;AACd;;AAEA;IACI,kBAAkB;IAClB,kBAAkB;AACtB;;AAEA;IACI,gBAAgB;IAChB,kBAAkB;IAClB,QAAQ;IACR,gBAAgB;IAChB,4BAA4B;AAChC;;AAEA;IACI;QACI,qCAAqC;IACzC;AACJ;;AAEA;IACI;QACI,0BAA0B;IAC9B;AACJ","sourcesContent":[".home_kpi_main {\n    max-width: 100%;\n    padding: 20px 24px;\n    border-radius: var(--radius-md);\n    background-color: var(--bg-card);\n    box-shadow: var(--shadow-sm);\n    border: 1px solid var(--border-light);\n}\n\n.kpi_container {\n    width: 100%;\n    display: grid;\n    grid-template-columns: repeat(3, 1fr);\n    gap: 14px;\n    padding: 16px 0 4px;\n}\n\n.kpi_box {\n    background-color: var(--bg-card);\n    max-width: 100%;\n    display: flex;\n    flex-direction: column;\n    justify-content: center;\n    align-items: end;\n    padding: 16px 20px;\n    gap: 6px;\n    border-radius: var(--radius-md);\n    border: 1px solid var(--border);\n    transition: all var(--transition-fast);\n}\n\n.kpi_box:hover {\n    box-shadow: var(--shadow-md);\n    border-color: var(--primary-50);\n}\n\n.kpi_box p {\n    margin: 0;\n}\n\n.kpi_box_datas {\n    display: flex;\n    flex-direction: row;\n    align-items: center;\n    gap: 10px;\n}\n\n.home_kpi_toggle {\n    width: 100%;\n    display: flex;\n    flex-direction: row;\n    justify-content: space-between;\n    align-items: center;\n}\n\n.home_kpi_toggle p {\n    margin: 0;\n    font-size: 15px;\n    font-weight: 600;\n    color: var(--text-primary);\n}\n\n.home_kpi_lists {\n    max-height: 0;\n    overflow: hidden;\n    transition: max-height 0.4s ease-in-out;\n}\n\n.home_kpi_lists_transition {\n    max-height: 5000px;\n}\n\n/************ TOGGLE ************/\n.toggle {\n    cursor: pointer;\n    display: inline-block;\n}\n\n.toggle-switch {\n    display: inline-block;\n    background: var(--border);\n    border-radius: 16px;\n    width: 44px;\n    height: 24px;\n    position: relative;\n    vertical-align: middle;\n    transition: background 0.25s;\n}\n\n.toggle-switch:before,\n.toggle-switch:after {\n    content: \"\";\n}\n\n.toggle-switch:before {\n    display: block;\n    background: var(--bg-card);\n    border-radius: 50%;\n    box-shadow: var(--shadow-sm);\n    width: 18px;\n    height: 18px;\n    position: absolute;\n    top: 3px;\n    left: 3px;\n    transition: left 0.25s;\n}\n\n.toggle:hover .toggle-switch:before {\n    box-shadow: var(--shadow-md);\n}\n\n.toggle-checkbox:checked + .toggle-switch {\n    background: var(--primary);\n}\n\n.toggle-checkbox:checked + .toggle-switch:before {\n    left: 23px;\n}\n\n.toggle-checkbox {\n    position: absolute;\n    visibility: hidden;\n}\n\n.toggle-label {\n    margin-left: 8px;\n    position: relative;\n    top: 2px;\n    font-weight: 500;\n    color: var(--text-secondary);\n}\n\n@media screen and (max-width: 1200px) {\n    .kpi_container {\n        grid-template-columns: repeat(2, 1fr);\n    }\n}\n\n@media screen and (max-width: 768px) {\n    .kpi_container {\n        grid-template-columns: 1fr;\n    }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
